import { jsx } from "react/jsx-runtime";
import { ChatMessage } from "pcln-design-system";
import "react";
import styled_components from "styled-components";
const StyledChatMessage = /*#__PURE__*/ styled_components(ChatMessage).withConfig({
    displayName: "CustomChatMessage__StyledChatMessage"
})([
    "overflow-wrap:break-word;word-break:break-word;hyphens:auto;& div:nth-child(2){width:fit-content;}@media (max-width:768px){& div:nth-child(2){width:auto;}}"
]);
const CustomChatMessage = (props)=>/*#__PURE__*/ jsx(StyledChatMessage, {
        ...props
    });
const CustomChatMessage_CustomChatMessage = CustomChatMessage;
export { CustomChatMessage_CustomChatMessage as default };
